/**
 * Audit tab — this org's ops access log.
 */
import { useState, useEffect } from 'react';
import { api } from '../../../api';

export default function OrgAuditTab({ org }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/ops_admin/audit?org_id=${org.id}&limit=200`)
      .then(d => setRows(d.audit || []))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, [org.id]);

  if (loading) return <p className="loading-text">Loading audit...</p>;
  if (error) return <p className="error-text">{error}</p>;

  return (
    <div className="ops-tab">
      <h2>Audit Log ({rows.length})</h2>
      <table className="ops-table ops-table-sm">
        <thead>
          <tr><th>Time</th><th>Actor</th><th>Action</th><th>Target</th><th>Reason</th></tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={5} className="empty-row">No audit records</td></tr>}
          {rows.map(r => (
            <tr key={r.id}>
              <td className="mono">{r.created_at ? new Date(r.created_at).toLocaleString() : '—'}</td>
              <td>{r.actor_email} <span className="role-badge">{r.actor_role}</span></td>
              <td className="mono action-cell">{r.action}</td>
              <td>{r.target_kind && `${r.target_kind}/${r.target_id?.slice(0, 8)}`}</td>
              <td className="reason-cell">{r.reason || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
